// The router, for whichever console this is (`src/surface.tsx`): the organisation console's routes
// (`src/org/routes.tsx`, spec/13 §1) or the HQ console's (`src/hq/routes.tsx`, spec/14).

import { createMemoryHistory, createRouter, type AnyRoute, type RouterHistory } from '@tanstack/react-router';

import type { OrgRouteTree } from './org/routes';
import type { RouterContext } from './routes/shared';

export type { RouterContext } from './routes/shared';

export function createConsoleRouter(context: RouterContext, routeTree: AnyRoute, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
    // A query's own cache decides freshness; the router never serves a stale loader result.
    defaultPreloadStaleTime: 0,
    ...(history === undefined ? {} : { history }),
  });
}

/** For tests: the console at one URL, with no browser history. */
export const memoryHistory = (url: string): RouterHistory => createMemoryHistory({ initialEntries: [url] });

// **Typed links are the organisation console's.** TanStack Router checks `to` and `params` against
// one registered route tree, and a build has one surface; the organisation console's is registered,
// so its many links are checked. The HQ console's few name their paths through `src/hq/paths.ts`,
// typed as plain strings, and its tests walk every one of them.
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter<OrgRouteTree>>;
  }
}
